import {useParams} from 'react-router-dom'
import React, { useState } from 'react'
import {SVFlyReviewTerrainCom} from '../containers'

function SVFlyReviewTerrainComPage() {
    let { id, addressId } = useParams();
    let svparams = { 'id': id}
    return (
            <SVFlyReviewTerrainCom svparams= {svparams} />
    );
}
/*

function AddressContainerComPage() {
    let { id, addressId } = useParams();
    let svparams = { 'id': id, 'addressId':addressId}
    return (
        <div style={{ fontSize: "50px" }}>
            Now AddressContainerComPage CustomerId {id}
            Now AddressContainerComPage Card Id  {addressId}
            <AddressContainerCom svparams= {svparams} />
      
           
        </div>
    );
}
*/
export default SVFlyReviewTerrainComPage